import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 2 }
const _hoisted_3 = ["colspan"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_table = _resolveComponent("v-table")!

  return (_openBlock(), _createBlock(_component_v_table, null, {
    default: _withCtx(() => [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableName, (tab, i) => {
            return (_openBlock(), _createElementBlock("th", {
              class: "text-left",
              key: i,
              style: {"cursor":"pointer"}
            }, _toDisplayString(tab), 1))
          }), 128))
        ])
      ]),
      (Array.isArray(_ctx.items))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_ctx.loading && _ctx.items.length == 0)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_1, [...(_cache[0] || (_cache[0] = [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, "Chargement....")
                  ], -1)
                ]))]))
              : (_ctx.items.length > 0)
                ? _renderSlot(_ctx.$slots, "default", { key: 1 })
                : (!_ctx.loading && _ctx.items.length == 0)
                  ? (_openBlock(), _createElementBlock("tbody", _hoisted_2, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", {
                          colspan: _ctx.items.length
                        }, [...(_cache[1] || (_cache[1] = [
                          _createElementVNode("span", { class: "text-center" }, "Aucun Enregistrement Trouvé", -1)
                        ]))], 8, _hoisted_3)
                      ])
                    ]))
                  : _createCommentVNode("", true)
          ], 64))
        : _renderSlot(_ctx.$slots, "default", { key: 1 })
    ]),
    _: 3
  }))
}